import { NgModule } from '@angular/core';
import { backendSearch, SearchModule } from '@shared/datastore/core';
import { searchContestsBackend } from './search-contests.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { transformSearchContests } from './search-contests.transformers';

backendSearch.searchContests = searchContestsBackend;

@NgModule({
  imports: [
    SearchModule.forFeature('searchContests', transformSearchContests),
    /* DatastoreBackendModule.forFeature(
      'searchContests',
      searchContestsTransformer,
    ),*/
  ],
})
export class DatastoreSearchContestsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-contests/search-contests.module.ts